import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

function IconAutomix({ color = Config.AUTOMIX_PRIMARY, className }) {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5749_7815)">
        <path d="M17.0316 8C18.1396 9.23698 18.7524 10.8393 18.7524 12.5C18.7524 14.1607 18.1396 15.763 17.0316 17M6.96846 17C5.8604 15.763 5.24769 14.1607 5.24769 12.5C5.24769 10.8393 5.8604 9.23698 6.96846 8M19.5 5.15187C21.4254 7.11306 22.5042 9.75163 22.5042 12.5C22.5042 15.2484 21.4254 17.8869 19.5 19.8481M4.50002 19.8481C2.57459 17.8869 1.49585 15.2484 1.49585 12.5C1.49585 9.75163 2.57459 7.11306 4.50002 5.15187M15 12.5C15 14.1568 13.6569 15.5 12 15.5C10.3432 15.5 9.00002 14.1568 9.00002 12.5C9.00002 10.8431 10.3432 9.5 12 9.5C13.6569 9.5 15 10.8431 15 12.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_5749_7815">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconAutomix.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
}

export default IconAutomix;
